import { FormValidationType, CUSTOM_VALIDATION_TYPES } from "../../../../types";
import { CLAIM_VALIDATION_CONSTANTS } from "../../../constants";
import { AlertModal } from "../../../../../components/alertModal/AlertModal";
import { createDismissCustomErrorHandler } from "../../../../validationUtils";

export const formFieldsValidation: FormValidationType = {
  [CLAIM_VALIDATION_CONSTANTS.ALL_CLAIM_VALIDATION_FIELDS]: {
    required: { value: false },
    [CUSTOM_VALIDATION_TYPES.ALL_ARE_VALID]: {
      value: true,
      fieldValidations: {
        [CLAIM_VALIDATION_CONSTANTS.PRODUCT_CAUSED_INJURIES_OR_DAMAGES]: {
          expectedValue: "true",
        },
        [CLAIM_VALIDATION_CONSTANTS.REQUESTING_ITEM_REMOVAL]: {
          expectedValue: "false",
        },
        [CLAIM_VALIDATION_CONSTANTS.SHARING_NEGATIVE_FEEDBACK]: {
          expectedValue: "false",
        },
        [CLAIM_VALIDATION_CONSTANTS.REFUND_REQUEST_ONLY]: {
          expectedValue: "false",
        },
        [CLAIM_VALIDATION_CONSTANTS.SEEKING_ADDITIONAL_COMPENSATION]: {
          expectedValue: "true",
        },
        [CLAIM_VALIDATION_CONSTANTS.DELIVERY_ISSUE_RELATED]: {
          expectedValue: "false",
        },
      },
      customError: (
        <AlertModal
          visible={true}
          header="Invalid IPL Claim"
          content={
            <span>
              Based on your answer(s), this does not appear to be a product liability claim. Please click cancel and update if you answered in error. Please reach out via this{" "}
              <a
                href="https://t.corp.amazon.com/create/templates/ab7c3b78-7569-4425-bd8f-d54ff377c46e"
                target="_blank"
                rel="noopener noreferrer"
              >
                ticket
              </a>
              {" "}if you need additional assistance.
            </span>
          }
          onDismiss={createDismissCustomErrorHandler(
            CLAIM_VALIDATION_CONSTANTS.FORM_NAME,
            CLAIM_VALIDATION_CONSTANTS.ALL_CLAIM_VALIDATION_FIELDS
          )}
        />
      ),
      message: "All validation criteria must be met for IPL claims",
    },
  },
  [CLAIM_VALIDATION_CONSTANTS.PRODUCT_CAUSED_INJURIES_OR_DAMAGES]: {
    required: { value: true },
  },
  [CLAIM_VALIDATION_CONSTANTS.REQUESTING_ITEM_REMOVAL]: {
    required: { value: true },
  },
  [CLAIM_VALIDATION_CONSTANTS.SHARING_NEGATIVE_FEEDBACK]: {
    required: { value: true },
  },
  [CLAIM_VALIDATION_CONSTANTS.REFUND_REQUEST_ONLY]: {
    required: { value: true },
  },
  [CLAIM_VALIDATION_CONSTANTS.SEEKING_ADDITIONAL_COMPENSATION]: {
    required: { value: true },
  },
  [CLAIM_VALIDATION_CONSTANTS.DELIVERY_ISSUE_RELATED]: {
    required: { value: true },
  },
};
